import { timelineEvents } from "@/mocks/homeMocks";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        {/* 标题 */}
        <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
          <span className="inline-block h-px w-8 bg-accent-500"></span>
          时间轴推理
        </p>
        <h2 className="font-heading mt-3 text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
          48 小时，一次翻车是如何一步步「实锤」的
        </h2>
        <p className="mt-3 max-w-3xl text-sm md:text-base leading-7 text-foreground-600">
          把同框、声明、删帖与反转入轴推演。不看单条截图，看整根轴上的先后与因果——顺序自己会说话。
        </p>

        {/* 横向推演轨 */}
        <div className="mt-10">
          <div className="relative hidden lg:block">
            <div className="absolute left-0 right-0 top-2 h-0.5 bg-gradient-to-r from-accent-200 via-accent-300 to-accent-100"></div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5 md:gap-5">
            {timelineEvents.map((e) => (
              <article
                key={e.time}
                className="group relative flex cursor-default flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300/70"
              >
                {/* 节点(桌面) */}
                <span className="mb-4 hidden h-4 w-4 items-center justify-center rounded-full border-2 border-accent-400 bg-background-50 lg:flex">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                </span>
                <div className="flex items-center gap-2">
                  <span className="font-heading whitespace-nowrap text-sm font-black text-accent-700">
                    {e.time}
                  </span>
                  <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                    {e.tag}
                  </span>
                </div>
                <h3 className="font-heading mt-3 text-base font-bold leading-snug text-foreground-950">
                  {e.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-500">{e.body}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}